module.exports = __webpack_public_path__ + "img/settext.1337c080.svg";